import { Modelo } from "../interfaces/modelo";
import imgDosdor01 from "../media/img/modelos/dosdor/Converted_WebP/portada.webp";
import imgDosdor02 from "../media/img/modelos/dosdor/Converted_WebP/27.webp";
import imgDosdor03 from "../media/img/modelos/dosdor/Converted_WebP/foto-156.webp";
import imgDosdor04 from "../media/img/modelos/dosdor/Converted_WebP/foto-17.webp";
import imgDosdor05 from "../media/img/modelos/dosdor/Converted_WebP/foto-21.webp";
import imgDosdor06 from "../media/img/modelos/dosdor/Converted_WebP/foto-22.webp";
import imgDosdor07 from "../media/img/modelos/dosdor/Converted_WebP/foto-26.webp";
import imgDosdor08 from "../media/img/modelos/dosdor/Converted_WebP/foto-30.webp";
import imgDosdor09 from "../media/img/modelos/dosdor/Converted_WebP/foto-32.webp";
import imgDosdor10 from "../media/img/modelos/dosdor/Converted_WebP/foto-4 (1).webp";
import imgDosdor11 from "../media/img/modelos/dosdor/Converted_WebP/foto-40.webp";
import imgDosdor12 from "../media/img/modelos/dosdor/Converted_WebP/image12_001 (1).webp";

import imgChillout01 from "../media/img/modelos/chillout/Portada.jpg";
import imgChillout02 from "../media/img/modelos/chillout/Converted_WebP/19.webp";
import imgChillout03 from "../media/img/modelos/chillout/Converted_WebP/231a6323-24d2-49df-aa61-193684ec2b40.webp";
import imgChillout04 from "../media/img/modelos/chillout/Converted_WebP/32 (1).webp";
import imgChillout05 from "../media/img/modelos/chillout/Converted_WebP/33.webp";
import imgChillout06 from "../media/img/modelos/chillout/Converted_WebP/5.webp";
import imgChillout07 from "../media/img/modelos/chillout/Converted_WebP/61.webp";
import imgChillout08 from "../media/img/modelos/chillout/Converted_WebP/717cf03a-c1bb-4885-b236-db2686fc01a5.webp";
import imgChillout09 from "../media/img/modelos/chillout/Converted_WebP/captura de pantalla (81).webp";
import imgChillout10 from "../media/img/modelos/chillout/Converted_WebP/po2.webp";
import imgChillout11 from "../media/img/modelos/chillout/Converted_WebP/whatsapp image 2022-11-14 at 11.46.19.webp";
import imgChilloutNewCaratula from "../media/img/modelos/chillout/new/Caratula.webp";
import imgChilloutNew01 from "../media/img/modelos/chillout/new/IMG_0882.webp";

import imgCabin01 from "../media/img/modelos/cabin/Converted_WebP/portada (1).webp";
import imgCabin02 from "../media/img/modelos/cabin/Converted_WebP/25.webp";
import imgCabin03 from "../media/img/modelos/cabin/Converted_WebP/45.webp";
import imgCabin04 from "../media/img/modelos/cabin/Converted_WebP/52 (1).webp";
import imgCabin05 from "../media/img/modelos/cabin/Converted_WebP/67.webp";
import imgCabin06 from "../media/img/modelos/cabin/Converted_WebP/7.webp";
import imgCabin07 from "../media/img/modelos/cabin/interior camara 2 blanco.jpg";
import imgCabin08 from "../media/img/modelos/cabin/interior camara blanco.jpg";
import imgCabin09 from "../media/img/modelos/cabin/Converted_WebP/whatsapp image 2024-02-06 at 10.38.29.webp";
import imgCabin10 from "../media/img/modelos/cabin/Converted_WebP/whatsapp image 2024-02-06 at 10.38.31.webp";
import imgCabin11 from "../media/img/modelos/cabin/Converted_WebP/whatsapp image 2024-02-06 at 10.48.50 (1).webp";
import imgCabinNewPortada from "../media/img/modelos/cabin/new/PORTADA 1.webp";
import imgCabinNew01 from "../media/img/modelos/cabin/new/IMG_0424 (2).webp";
import imgCabinNew02 from "../media/img/modelos/cabin/new/IMG_0825 (1).webp";
import imgCabinNew03 from "../media/img/modelos/cabin/new/IMG_0923.webp";
import imgCabinNew04 from "../media/img/modelos/cabin/new/IMG_0924.webp";
import imgCabinNew05 from "../media/img/modelos/cabin/new/IMG_0927.webp";
import imgCabinNew06 from "../media/img/modelos/cabin/new/IMG_0928.webp";
import imgCabinNew07 from "../media/img/modelos/cabin/new/IMG_0929.webp";
import imgCabinNew08 from "../media/img/modelos/cabin/new/IMG_0930.webp";
import imgCabinNew09 from "../media/img/modelos/cabin/new/IMG_0931.webp";
import imgCabinNew10 from "../media/img/modelos/cabin/new/IMG_0932.webp";
import imgCabinNew11 from "../media/img/modelos/cabin/new/IMG_0934.webp";
import imgCabinNew12 from "../media/img/modelos/cabin/new/IMG_0936.webp";
import imgCabinNew13 from "../media/img/modelos/cabin/new/IMG_0937.webp";
import imgCabinNew14 from "../media/img/modelos/cabin/new/IMG_0938.webp";
import imgCabinNew15 from "../media/img/modelos/cabin/new/IMG_2946.webp";

import imgKubePortada from "../media/img/modelos/kube/PORTADA.webp";
import imgKube01 from "../media/img/modelos/kube/PORTADA.jpg";
import imgKube02 from "../media/img/modelos/kube/Converted_WebP/2d9fb1d5-e0b7-4b6d-922c-83bd9041f5ab (1).webp";
import imgKube03 from "../media/img/modelos/kube/Converted_WebP/51.webp";
import imgKube04 from "../media/img/modelos/kube/Converted_WebP/53.webp";
import imgKube05 from "../media/img/modelos/kube/Converted_WebP/56.webp";
import imgKube06 from "../media/img/modelos/kube/Converted_WebP/aerea (1).webp";
import imgKube07 from "../media/img/modelos/kube/Converted_WebP/fa48eecf-74b0-4445-a4fd-54e5fba45faa (1).webp";
import imgKube08 from "../media/img/modelos/kube/Converted_WebP/fb33ef6e-093b-402c-9602-e559ae534045.webp";
import imgKube09 from "../media/img/modelos/kube/Converted_WebP/frente casa izq madera.webp";
import imgKube10 from "../media/img/modelos/kube/Converted_WebP/image15 (1).webp";
import imgKube11 from "../media/img/modelos/kube/Converted_WebP/img_0621 (1).webp";
import imgKube12 from "../media/img/modelos/kube/Converted_WebP/img_1991 (1).webp";

import imgDosdor2Portada from "../media/img/modelos/dosdor2/Portada en Sección Modelos.webp";
import imgDosdor2Foto01 from "../media/img/modelos/dosdor2/Foto 1.webp";
import imgDosdor2Foto02 from "../media/img/modelos/dosdor2/Foto 2.webp";
import imgDosdor2Foto03 from "../media/img/modelos/dosdor2/Foto 3.webp";
import imgDosdor2Foto04 from "../media/img/modelos/dosdor2/Foto 4.webp";
import imgDosdor2Foto05 from "../media/img/modelos/dosdor2/Foto 5.webp";
import imgDosdor2Foto06 from "../media/img/modelos/dosdor2/Foto 6.webp";
import imgDosdor2Foto07 from "../media/img/modelos/dosdor2/Foto 7.webp";
import imgDosdor2Foto08 from "../media/img/modelos/dosdor2/Foto 8.webp";
import imgDosdor2Foto09 from "../media/img/modelos/dosdor2/Foto 9.webp";
import imgDosdor2Foto10 from "../media/img/modelos/dosdor2/Foto 10.webp";
import imgDosdor2Foto11 from "../media/img/modelos/dosdor2/Foto 11.webp";
import imgDosdor2Foto12 from "../media/img/modelos/dosdor2/Foto 12.webp";
import imgDosdor2Foto13 from "../media/img/modelos/dosdor2/Foto 13.webp";
import imgDosdor2Foto14 from "../media/img/modelos/dosdor2/Foto 14.webp";

import imgD60Portada from "../media/img/modelos/D60/Portada Sección Modelos.webp";
import imgD60Foto01 from "../media/img/modelos/D60/Foto 1.webp";
import imgD60Foto02 from "../media/img/modelos/D60/Foto 2.webp";
import imgD60Foto03 from "../media/img/modelos/D60/Foto 3.webp";
import imgD60Foto04 from "../media/img/modelos/D60/Foto 4.webp";
import imgD60Foto05 from "../media/img/modelos/D60/Foto 5.webp";
import imgD60Foto06 from "../media/img/modelos/D60/Foto 6.webp";
import imgD60Foto07 from "../media/img/modelos/D60/Foto 7.webp";
import imgD60Foto08 from "../media/img/modelos/D60/Foto 8.webp";
import imgD60Foto09 from "../media/img/modelos/D60/Foto 9.webp";
import imgD60Foto10 from "../media/img/modelos/D60/Foto 10.webp";
import imgD60Foto11 from "../media/img/modelos/D60/Foto 11.webp";
import imgD60Foto12 from "../media/img/modelos/D60/Foto 12.webp";
import imgD60Foto13 from "../media/img/modelos/D60/Foto 13.webp";

const BROCHURE_URL = "https://drive.google.com/file/d/1YAy91ss8_aDBiCobdF5oDUYOg8GPbncK/view";

export const MockModelos: Modelo[] = [
    {
        id: 1,
        nombre: 'Cabin',
        // descripcion: `El concepto orientativo planteado ene l brochure puede ser modificado por el cliente, según conveniencia.
        //               Este modelo de fabricación estandar, permite elegir al usuario si desea toilette + baño, 2 dormitorios, dormitorio, vestidor y estudio, opciones de ubicaciones, cantidades y morfología de carpinterías.`,
        descripcion: `20m2\n
Monoambiente - 1 baño - deck semicubierto\n
Un espacio adaptable, un único ambiente donde se integran cocina, baño, living, comedor y dormitorio.\n
Pensado para refugio, glamping, hotel boutique, casa de huéspedes o atelier.\n\n
Propio al espíritu DROP, al estar compuesto por un solo módulo, terminado en fábrica, facilita su velocidad de construcción y sencilla implantación. Llevalo a DONDE QUIERAS.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgCabinNewPortada }, { id: 2, nombre: 'Imagen02', url: imgCabin02 }, { id: 3, nombre: 'Imagen03', url: imgCabin03 }, { id: 4, nombre: 'Imagen04', url: imgCabin04 },
        { id: 5, nombre: 'Imagen05', url: imgCabin05 }, { id: 6, nombre: 'Imagen06', url: imgCabin06 }, { id: 7, nombre: 'Imagen07', url: imgCabin07 }, { id: 8, nombre: 'Imagen08', url: imgCabin08 },
        { id: 9, nombre: 'Imagen09', url: imgCabin09 }, { id: 10, nombre: 'Imagen10', url: imgCabin10 }, { id: 11, nombre: 'Imagen11', url: imgCabin11 },

        { id: 1, nombre: 'Imagen01', url: imgCabinNew01 }, { id: 2, nombre: 'Imagen02', url: imgCabinNew02 }, { id: 3, nombre: 'Imagen03', url: imgCabinNew03 },
        { id: 4, nombre: 'Imagen04', url: imgCabinNew04 }, { id: 5, nombre: 'Imagen05', url: imgCabinNew05 }, { id: 6, nombre: 'Imagen06', url: imgCabinNew06 },
        { id: 7, nombre: 'Imagen07', url: imgCabinNew07 }, { id: 8, nombre: 'Imagen08', url: imgCabinNew08 }, { id: 9, nombre: 'Imagen09', url: imgCabinNew09 },
        { id: 10, nombre: 'Imagen10', url: imgCabinNew10 }, { id: 11, nombre: 'Imagen11', url: imgCabinNew11 }, { id: 12, nombre: 'Imagen12', url: imgCabinNew12 },
        { id: 13, nombre: 'Imagen13', url: imgCabinNew13 }, { id: 14, nombre: 'Imagen14', url: imgCabinNew14 }, { id: 15, nombre: 'Imagen15', url: imgCabinNew15 },
        ],
        caracteristicas: [{ id: 1, descripcion: 'Monombiente | 20 m2' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 2,
        nombre: 'Chillout',
        descripcion: `60m2\n
32m2 cub + 28m2 semicub\n
1 dormitorio + 1 baño + deck semicubierto\n
Ideal para primera vivienda.\n
El modelo habitacional más práctico puede modularse como amplio loft o con dormitorio independiente de la cocina-living-comedor.\n
La versión completa del Chillout suma 28 m2 de deck semicubierto que extienden el estar hacia el parque. Escalable y ampliable a futuro.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgChilloutNewCaratula }, { id: 2, nombre: 'Imagen02', url: imgChillout02 }, { id: 3, nombre: 'Imagen03', url: imgChillout03 },
        { id: 4, nombre: 'Imagen04', url: imgChillout04 }, { id: 5, nombre: 'Imagen05', url: imgChillout05 }, { id: 6, nombre: 'Imagen06', url: imgChillout06 },
        { id: 7, nombre: 'Imagen07', url: imgChillout07 }, { id: 8, nombre: 'Imagen08', url: imgChillout08 }, { id: 9, nombre: 'Imagen09', url: imgChillout09 },
        { id: 10, nombre: 'Imagen10', url: imgChillout10 }, { id: 11, nombre: 'Imagen11', url: imgChillout11 }, { id: 12, nombre: 'Imagen12', url: imgChilloutNew01 },
        ],
        caracteristicas: [{ id: 1, descripcion: '1 Dormitorio | 32 m2 cubiertos' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 3,
        nombre: 'H1',
        descripcion: `105m2\n
70m2 cub + 35m2 semicub\n
Una casa amplia y abierta al exterior.\n
Funcional, con un dormitorio, vestidor/estudio/segundo dormitorio.\n
Baño completo y toilette independiente.\n
Un gran espacio social que se abre a un deck, ideal para una vida social o en familia.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgDosdor01 }, { id: 2, nombre: 'Imagen02', url: imgDosdor02 }, { id: 3, nombre: 'Imagen03', url: imgDosdor03 }, { id: 4, nombre: 'Imagen04', url: imgDosdor04 },
        { id: 5, nombre: 'Imagen05', url: imgDosdor05 }, { id: 6, nombre: 'Imagen06', url: imgDosdor06 }, { id: 7, nombre: 'Imagen07', url: imgDosdor07 }, { id: 8, nombre: 'Imagen08', url: imgDosdor08 },
        { id: 9, nombre: 'Imagen09', url: imgDosdor09 }, { id: 10, nombre: 'Imagen10', url: imgDosdor10 }, { id: 11, nombre: 'Imagen11', url: imgDosdor11 }, { id: 12, nombre: 'Imagen12', url: imgDosdor12 }
        ],
        caracteristicas: [{ id: 1, descripcion: '1 Dormitorio | 70 m2 cubiertos' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 4,
        nombre: 'Dosdor',
        descripcion: `2 dormitorios + deck semicubierto (6 módulos)
70m2\n
La casa que siempre quisiste.\n
Se personaliza según la implantación y orientación del terreno el espacio único cocina-living-comedor genera un ambiente amplio y con clara conexión al exterior.\n
Se puede personalizar según intenciones del cliente, implantación y orientación del terreno.\n
Como todos nuestros modelos, puede ser fácilmente ampliable para sumar ambientes independientes o rediseñarlo interiormente, según deseo del cliente.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [
            { id: 1, nombre: 'Portada', url: imgDosdor2Portada },
            { id: 2, nombre: 'Foto 01', url: imgDosdor2Foto01 },
            { id: 3, nombre: 'Foto 02', url: imgDosdor2Foto02 },
            { id: 4, nombre: 'Foto 03', url: imgDosdor2Foto03 },
            { id: 5, nombre: 'Foto 04', url: imgDosdor2Foto04 },
            { id: 6, nombre: 'Foto 05', url: imgDosdor2Foto05 },
            { id: 7, nombre: 'Foto 06', url: imgDosdor2Foto06 },
            { id: 8, nombre: 'Foto 07', url: imgDosdor2Foto07 },
            { id: 9, nombre: 'Foto 08', url: imgDosdor2Foto08 },
            { id: 10, nombre: 'Foto 09', url: imgDosdor2Foto09 },
            { id: 11, nombre: 'Foto 10', url: imgDosdor2Foto10 },
            { id: 12, nombre: 'Foto 11', url: imgDosdor2Foto11 },
            { id: 13, nombre: 'Foto 12', url: imgDosdor2Foto12 },
            { id: 14, nombre: 'Foto 13', url: imgDosdor2Foto13 },
            { id: 15, nombre: 'Foto 14', url: imgDosdor2Foto14 },
        ],
        caracteristicas: [{ id: 1, descripcion: '2 dormitorios + deck semicubierto | 70 m2 cubiertos' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 5,
        nombre: 'D60',
        descripcion: `61m2\n 
49m2 cub + 12m2 semicub\n 
Una casa con dos dormitorios, baño completo y living comedor con cocina integrada.\n 
Un deck semicubierto que funciona perfecto de espacio intermedio entre el living y el exterior.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [
            { id: 1, nombre: 'Portada', url: imgD60Portada },
            { id: 2, nombre: 'Foto 01', url: imgD60Foto01 },
            { id: 3, nombre: 'Foto 02', url: imgD60Foto02 },
            { id: 4, nombre: 'Foto 03', url: imgD60Foto03 },
            { id: 5, nombre: 'Foto 04', url: imgD60Foto04 },
            { id: 6, nombre: 'Foto 05', url: imgD60Foto05 },
            { id: 7, nombre: 'Foto 06', url: imgD60Foto06 },
            { id: 8, nombre: 'Foto 07', url: imgD60Foto07 },
            { id: 9, nombre: 'Foto 08', url: imgD60Foto08 },
            { id: 10, nombre: 'Foto 09', url: imgD60Foto09 },
            { id: 11, nombre: 'Foto 10', url: imgD60Foto10 },
            { id: 12, nombre: 'Foto 11', url: imgD60Foto11 },
            { id: 13, nombre: 'Foto 12', url: imgD60Foto12 },
            { id: 14, nombre: 'Foto 13', url: imgD60Foto13 },
        ],
        caracteristicas: [{ id: 1, descripcion: '2 dormitorios | 49 m2 cubiertos' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 6,
        nombre: 'Tu Drop personalizado',
        descripcion: `Desde DROP entendemos que la flexibilidad a tus necesidades es fundamental, por eso tenemos el objetivo firme de adaptar cada propuesta a las búsquedas particulares de cada uno. Desarrollamos propuestas residenciales contemporáneas, privilegiando espacios espaciosos, muy luminosos y equipados con excelente circulación de aire.\n
Un planteo sumamente versátil, apto para lotes de dimensiones generosas o parcelas urbanas entre medianeras. En estas últimas, se logra un frente muy estético que cuida las vistas privadas, combinado con un contrafrente acristalado orientado al verde. Además, integra patios interiores que aportan luz natural y flujo de aire a los sectores contiguos.\n
Esta adaptabilidad espacial admite múltiples configuraciones dinámicas optimizando la superficie, en respuesta al ritmo actual. El resultado: recintos con un gran aislamiento termoacústico que aprovechan al máximo el sol.\n
Recordá que un Drop no es solamente una vivienda, puede ser la expansión de tu casa, un quincho, un taller, un local comercial o cualquier otro espacio que necesites.`,
        valor: 40000,
        moneda: 'USD$',
        brochure: BROCHURE_URL,
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [{ id: 0, nombre: 'Imagen00', url: imgKubePortada },
        { id: 1, nombre: 'Imagen01', url: imgKube01 }, { id: 2, nombre: 'Imagen02', url: imgKube02 }, { id: 3, nombre: 'Imagen03', url: imgKube03 }, { id: 4, nombre: 'Imagen04', url: imgKube04 },
        { id: 5, nombre: 'Imagen05', url: imgKube05 }, { id: 6, nombre: 'Imagen06', url: imgKube06 }, { id: 7, nombre: 'Imagen07', url: imgKube07 }, { id: 8, nombre: 'Imagen08', url: imgKube08 },
        { id: 9, nombre: 'Imagen09', url: imgKube09 }, { id: 10, nombre: 'Imagen10', url: imgKube10 }, { id: 11, nombre: 'Imagen11', url: imgKube11 }, { id: 12, nombre: 'Imagen12', url: imgKube12 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    },
]